module.exports = __webpack_public_path__ + "static/media/HIC2.be90b318.jpg";